import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Hook to determine if the current user has manager-level access
 * Used for gating visibility of sensitive information like DCS scores
 */
export function useUserRole() {
  const { user } = useAuth();

  const { data: membership, isLoading } = useQuery({
    queryKey: ['user-membership-role', user?.id],
    queryFn: async () => {
      if (!user?.id) return null;
      
      const { data, error } = await supabase
        .from('memberships')
        .select('role')
        .eq('user_id', user.id)
        .eq('status', 'active')
        .single();
      
      if (error) {
        console.error('Error fetching user role:', error);
        return null;
      }
      
      return data;
    },
    enabled: !!user?.id,
  });

  const role = membership?.role;
  
  // Manager-level roles that can see diagnostic scores and role passports
  const isManagerView = role === 'MANAGER' || role === 'OWNER';
  
  // Owner-level roles for manager passport visibility
  const isOwnerView = role === 'OWNER' || role === 'MANAGER';
  
  return {
    role,
    isManagerView,
    isOwnerView,
    isOwner: role === 'OWNER',
    isLoading,
  };
}
